<template>
  <div class="w100 Contenido aliCenter">
    <!-- <div class="w100 FondoMaiz">
      <img src="../assets/ico-maiz-int.png" alt="ImagenMaiz" class="ImagenMaiz dIB" />
      <div class="w100 aliCenter B">MAIZ PLUS</div>
    </div> -->
    <div class="w100 aliCenter">
      <img src="../assets/logo-maiz-plus.png" alt="LogoMaizPlus" class="LogoMaizPlus">
    </div>

    <div class="w100 aliLeft TextoComun">
      <div class="fs12em w100 aliCenter B">¿Qué es MAÍZ PLUS?</div>
      <div class="mT20">
      Consiste en un servicio, brindado por la empresa <b>Agroideas</b>, a través de 10 herramientas de alta precisión, cuyo objetivo es la optimización de los recursos necesarios para el desarrollo de los cultivos, logrando la máxima eficacia y eficiencia en producción.
      <br>
      De esta manera, el productor podrá alcanzar los mejores márgenes en productividad y rentabilidad dentro de su empresa.
      </div>
    </div>

    <div class="w100 SeccionLinks mT10">
      <div class="w100 aliLeft TextoComun">
        <div class="w100 aliCenter">
          <br>
          <div class="B fs12em">Herramientas de MAÍZ PLUS</div>

          <div class="mT20"></div>
          <router-link class="nU Link"
            v-for="herr in Herramientas.GetValues()"
            :key="herr.id"
            :to="herr.path"
          >
            {{ herr.title }}
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Clases from "../Auxiliares/Clases.js";
import { Herramientas } from "../Auxiliares/Enums";
// import axios from 'axios';
export default {
  name: "SeccionMaizPlus",
  data(){
    return{
        Herramientas
    }
  },
  created() {
  },
  beforeMount () {
  },
  mounted() {
  },
  methods: {
  },
  components: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../Css/Globales.css';
  @import '../Css/AgroIdeas.scss';
  .SeccionLinks{
    background-color: rgba(0,0,0,0.05);
  }
  .Contenido{
    color:#222;
  }
  .Link{
    color: #628212;
    box-sizing: border-box;
    padding:7px 10px;
    width:100%;
    line-height: 25px;
    display:block;
    font-style: italic;
    text-decoration: underline;
  }
  .Link:hover{ color: #37490A; cursor: pointer;}
  .TextoComun{
    text-align:justify;
    line-height: 30px;
    box-sizing: border-box;
    padding:5px 10%;
  }
  .LogoMaizPlus{
      margin-top:20px;
    max-width:380px;
    width:100%;
  }
  .FondoMaiz{
    background-color:#005625; color:white;
    font-size: 1.9em;
    padding:20px 0;
  }
  .Contenido {
    margin: 50px 0px;
    font-size: 1.2em;
  }
  .ImagenMaiz{
    height:65px;
  }

  @media (max-width: 799px) {
    /* mobile */
    .LogoMaizPlus{ width:96%; }
    .TextoComun{ padding:5px 10px; }
  }
</style>
